import { VueGoodTable } from 'vue-good-table';
import { API, ENDPOINTS } from '@/app/services/api-url';
import EventBus from '@/app/eventBus';

export default {
  name: 'fund-datatable',
  components: {
    VueGoodTable,
  },
  data: () => ({
    isLoading: true,
    fundChosen: false,
    selectedFund: '',
    rows: [],
  }),
  props: {
    columns: {
      type: Array,
      default: () => [
        {
          label: 'Fund',
          field: 'fundName',
          filterOptions: {
            enabled: true,
            placeholder: 'Fund Name',
          },
        },
        {
          label: '',
          field: 'menu',
          sortable: false,
          width: '75px',
        },

      ],
    },
    inputType: {
      type: String,
      default: '',
    },
  },
  computed: {
    accountUserUUID() {
      return this.$store.getters['account/getActiveAccountUser'].uuid;
    },
  },
  methods: {
    handleSelectFund(fundId) {
      this.$emit('fundId', fundId);
    },
    async loadFunds() {
      try {
        const { accessTokens } = this.$store.getters['account/getActiveAccountUser'];
        const submitAccessTokens = {};
        if (accessTokens.bgl !== undefined && this.inputType.toLowerCase().includes('bgl')) {
          submitAccessTokens.bgl = accessTokens.bgl;
        }
        if (accessTokens.class !== undefined && this.inputType.toLowerCase().includes('class')) {
          submitAccessTokens.class = accessTokens.class;
        }
        const response = await API.post(
          `${ENDPOINTS.POST_INTEGRATION_GET_FUNDS}`,
          {
            accessTokens: submitAccessTokens,
          },
        );
        if (response.status === 200) {
          this.rows = response.data.funds.map(item => ({
            id: item.fundID,
            fundName: item.fundName,
          }));
          this.isLoading = false;
        }
      } catch (err) {
        EventBus.$emit('addNotification', {
          title: 'Error loading funds',
          icon: 'cross',
          message: 'Could not load funds for display, please try again',
        });

        if (err.response.status === 400) {
          const error = err.response.data.error.errorMessage;
          if (error.includes('Invalid access token')) {
            API.patch(`${ENDPOINTS.PATCH_ACCESS_TOKEN}/${this.accountUserUUID}/accesstoken?type=bgl`)
              .then((res) => {
                if (res.status === 201) {
                  return this.$store.dispatch('account/refreshAccounts');
                }
                throw new Error('Failed to revoke access token!');
              })
              .then(() => {
                this.isLoading = false;
              })
              .catch(accessTokenErr => console.log(accessTokenErr));
            this.$emit('invalid-token');
          }
          if (error.includes('Class')) {
            API.patch(`${ENDPOINTS.PATCH_ACCESS_TOKEN}/${this.accountUserUUID}/accesstoken?type=class`)
              .then((res) => {
                if (res.status === 201) {
                  return this.$store.dispatch('account/refreshAccounts');
                }
                throw new Error('Failed to revoke access token!');
              })
              .then(() => {
                this.isLoading = false;
              })
              .catch(accessTokenErr => console.log(accessTokenErr));
            this.$emit('invalid-token');
          }
        }
        this.isLoading = false;
      }
    },
  },
  mounted() {
    this.loadFunds();
  },
  watch: {
    inputType: {
      immediate: true,
      async handler() {
        this.isLoading = true;
        await this.loadFunds();
      },
    },
  },
};
